// Transitional English translations for legacy authentication, workforce,
// administration, planning, tachograph, profitability, and notification UI.
//
// Only interface-owned copy belongs here. User-entered values, company data,
// addresses, document content, and other business data must remain unchanged.
// New or actively edited UI should use semantic i18next keys instead.

export const legacyEnglishOperations = Object.freeze({
  // Shared driver and document components
  'Te rog completează toate câmpurile obligatorii': 'Please complete all required fields',
  'Încarcă un document nou': 'Upload a new document',
  'Selectează un fișier': 'Select a file',
  'Selectează un fișier pentru a continua': 'Select a file to continue',
  'Data expirării trebuie să fie în formatul AAAA-LL-ZZ': 'The expiry date must use the YYYY-MM-DD format',
  'Selectează Fișier': 'Select File',
  'Click pentru a selecta un fișier': 'Click to select a file',
  'PDF, JPG, PNG, DOC până la 10MB': 'PDF, JPG, PNG, or DOC up to 10 MB',
  'Data angajării': 'Employment date',
  'Istoric și foaie nouă': 'History and new trip sheet',
  'Adaugă doc.': 'Add document',
  'Nu am putut încărca istoricul diurnelor.': 'Could not load the per diem history.',
  'Selectează o lună validă.': 'Select a valid month.',
  'Nu am putut salva diurna lunară.': 'Could not save the monthly per diem.',
  'Configurează o lună nouă sau selectează o lună din istoric pentru editare.': 'Configure a new month or select a month from the history to edit it.',
  'Închide diurnele': 'Close per diem settings',
  'Sumă / zi': 'Amount / day',
  'Salvează diurna': 'Save per diem',
  'Se încarcă istoricul…': 'Loading history…',
  'Nu există diurne lunare configurate pentru acest șofer.': 'No monthly per diem is configured for this driver.',
  'Luna curentă:': 'Current month:',
  'Total luna curentă': 'Current month total',
  'Nu există bonuri pentru luna curentă': 'There are no receipts for the current month',
  'Bon fără descriere': 'Receipt without a description',
  'Nu există șoferi': 'No drivers',
  'Nu există șoferi înregistrați în sistem.': 'There are no drivers registered in the system.',
  'Caută șofer după nume, email sau companie...': 'Search for a driver by name, email, or company...',
  'Șterge filtre': 'Clear filters',
  'Transport fără număr': 'Transport without a number',
  'Nu aveți permisiunea să accesați coada acestui șofer.': "You do not have permission to access this driver's queue.",
  'Eroare la încărcarea cozii:': 'Error loading the queue:',
  'Ordinea transporturilor a fost salvată cu succes.': 'The transport order was saved successfully.',
  'Eroare la salvarea ordinii:': 'Error saving the order:',
  'Nu există transporturi în coadă': 'There are no transports in the queue',
  '• Aveți modificări nesalvate. Faceți clic pe "Salvează" pentru a le aplica.': '• You have unsaved changes. Click "Save" to apply them.',
  'Lipsesc datele necesare pentru actualizare.': 'The information required for the update is missing.',
  'Numele șoferului nu poate fi gol.': "The driver's name cannot be empty.",
  'Introduceți o adresă de email validă.': 'Enter a valid email address.',
  'Introduceți un număr de telefon valid (7XX XXX XXX).': 'Enter a valid phone number (7XX XXX XXX).',
  'Salariul pentru profitabilitate trebuie să fie un număr pozitiv.': 'The profitability salary must be a positive number.',
  'Data nașterii trebuie să fie validă și să nu fie în viitor.': 'The date of birth must be valid and cannot be in the future.',
  'Data angajării nu poate fi înainte de data nașterii.': 'The employment date cannot be earlier than the date of birth.',
  'Informațiile șoferului au fost actualizate cu succes.': "The driver's information was updated successfully.",
  'Nu am putut salva modificările. Vă rugăm încercați din nou.': 'Could not save the changes. Please try again.',
  'Editare Informații Șofer': 'Edit Driver Information',
  'Modificări salvate': 'Changes saved',
  'Data Nașterii': 'Date of Birth',
  'Data Angajării': 'Employment Date',
  'Poate transporta mărfuri periculoase': 'Can transport dangerous goods',
  'Șoferul poate transporta materiale clasificate ca periculoase (ADR)': 'The driver may transport materials classified as dangerous goods (ADR)',
  'Poate transporta mărfuri refrigerate': 'Can transport refrigerated goods',
  'Șoferul poate opera vehicule cu sisteme de refrigerare': 'The driver may operate vehicles equipped with refrigeration systems',
  'A intervenit o problemă.': 'Something went wrong.',
  'Cererea de concediu a fost aprobată.': 'The leave request was approved.',
  'Respins de către dispecer': 'Rejected by the dispatcher',
  'Cererea de concediu a fost respinsă.': 'The leave request was rejected.',
  'Documentul a fost încărcat.': 'The document was uploaded.',
  'Sigur doriți să ștergeți documentul acestei cereri?': 'Are you sure you want to delete the document attached to this request?',
  'Cereri': 'Requests',
  'Sâm': 'Sat',
  'Înlocuiește document': 'Replace document',
  'Eroare la generarea raportului lunar:': 'Error generating the monthly report:',
  'Eroare la generarea raportului anual:': 'Error generating the annual report:',
  'Perioada': 'Period',
  'Luna': 'Month',
  'Ambele câmpuri sunt obligatorii': 'Both fields are required',
  'Parola trebuie să aibă minim 8 caractere': 'The password must be at least 8 characters long',
  'Parola trebuie să conțină cel puțin o literă și o cifră': 'The password must contain at least one letter and one number',
  'Resetează Parola': 'Reset Password',
  'Veți reseta parola pentru acest șofer': 'You are about to reset the password for this driver',
  'Parola trebuie să aibă minim 8 caractere și să conțină cel puțin o literă și o cifră': 'The password must be at least 8 characters long and contain at least one letter and one number',
  'Parolă Nouă': 'New Password',
  'Confirmă Parola': 'Confirm Password',

  // Shared application, navigation, and form components
  'A apărut o problemă!': 'Something went wrong!',
  'Ne pare rău, dar a avut loc o eroare neașteptată. Vă rugăm să reîncărcați pagina.': 'Sorry, an unexpected error occurred. Please reload the page.',
  'Reîncarcă Pagina': 'Reload Page',
  'Selectează țara': 'Select country',
  'Caută după nume sau cod...': 'Search by name or code...',
  'Nu există rezultate.': 'No results found.',
  'Confirmare Ștergere': 'Confirm Deletion',
  'Ești sigur că vrei să ștergi acest element? Această acțiune nu poate fi anulată.': 'Are you sure you want to delete this item? This action cannot be undone.',
  'Da, Șterge': 'Yes, Delete',
  'Ești sigur că vrei să ștergi': 'Are you sure you want to delete',
  'Această acțiune nu poate fi anulată.': 'This action cannot be undone.',
  'Caută țara sau prefixul': 'Search for a country or dialling code',
  'Prima pagină': 'First page',
  'Ultima pagină': 'Last page',
  'Caută...': 'Search...',
  'Utilizator': 'User',
  'Se verifică accesul la modul...': 'Checking module access...',
  'Service & Intervenții': 'Service & Interventions',
  'Înregistrare': 'Register',

  // Notification components
  'Status Conexiune Notificări': 'Notification Connection Status',
  'Vă rugăm să vă autentificați pentru a primi notificări.': 'Please sign in to receive notifications.',
  'Se încarcă notificările...': 'Loading notifications...',
  'Notificările vor apărea aici când vor fi disponibile': 'Notifications will appear here when available',
  'Încearcă să te reconectezi': 'Try reconnecting',
  'Atenție': 'Attention',
  'Închide notificarea': 'Close notification',
  'Număr Colete': 'Number of Packages',
  'Total de Plată': 'Total Amount Due',
  'Greutate Brută': 'Gross Weight',
  'Natura Mărfii': 'Nature of Goods',
  'Data Încărcare': 'Loading Date',
  'Localitate Încărcare': 'Loading Location',
  'Țară Încărcare': 'Loading Country',
  'Țară Livrare': 'Delivery Country',
  'Adresă Expeditor': 'Sender Address',
  'Adresă Destinatar': 'Recipient Address',
  'Nume Șofer': 'Driver Name',
  'Număr Camion': 'Truck Registration Number',
  'Număr Remorcă': 'Trailer Registration Number',
  'Valută': 'Currency',
  'Status Plată': 'Payment Status',
  'Document Expiră': 'Document Expiring',
  'Comandă Nouă': 'New Order',
  'Ați primit o comandă nouă': 'You have received a new order',
  'Actualizare status șofer': 'Driver status update',
  'Notificare nouă': 'New notification',
  '🔄 Reîmprospătare manuală a notificărilor': '🔄 Refresh notifications manually',
  'Reîmprospătarea notificărilor a eșuat:': 'Could not refresh notifications:',
  'Marchează tot ca citit': 'Mark all as read',
  'Șterge tot': 'Delete all',
  'Nu aveți notificări în acest moment.': 'You have no notifications at the moment.',
  'Șterge notificarea': 'Delete notification',
  'Încarcă mai multe notificări': 'Load more notifications',

  // Profile and account components
  'Toate câmpurile sunt obligatorii.': 'All fields are required.',
  'Parola nouă trebuie să aibă minim 8 caractere.': 'The new password must be at least 8 characters long.',
  'Parola nouă trebuie să conțină cel puțin o literă și o cifră.': 'The new password must contain at least one letter and one number.',
  'Parola nouă trebuie să fie diferită de parola actuală.': 'The new password must be different from the current password.',
  'Eroare la schimbarea parolei.': 'Error changing the password.',
  'Parola actuală': 'Current password',
  'Introdu parola actuală': 'Enter your current password',
  'Parola nouă': 'New password',
  'are literă': 'contains a letter',
  'are cifră': 'contains a number',
  'Se schimbă...': 'Changing...',
  'Încarcă documente': 'Upload documents',
  'Vă rugăm să completați toate câmpurile obligatorii': 'Please complete all required fields',
  'Eroare la încărcarea documentelor': 'Error loading documents',
  'Sunteți sigur că doriți să ștergeți acest document?': 'Are you sure you want to delete this document?',
  'document încărcat': 'document uploaded',
  'documente încărcate': 'documents uploaded',
  'Țara trebuie să fie cod ISO din 2 litere, de exemplu RO.': 'The country must be a two-letter ISO code, for example RO.',
  'Selectează un fus orar IANA valid, de exemplu Europe/Bucharest.': 'Select a valid IANA time zone, for example Europe/Bucharest.',
  'Vă rugăm să adăugați mai întâi o adresă de email.': 'Please add an email address first.',
  'A apărut o eroare. Vă rugăm încercați din nou.': 'An error occurred. Please try again.',
  'Funcționalitatea de schimbare parolă nu este disponibilă momentan.': 'Password changes are currently unavailable.',
  'Nu am putut schimba parola.': 'Could not change the password.',
  'Parola a fost schimbată cu succes.': 'The password was changed successfully.',
  'Introdu o adresă de email validă.': 'Enter a valid email address.',
  'Parola este necesară pentru a schimba email-ul': 'Your password is required to change the email address',
  'Funcționalitatea de actualizare email nu este disponibilă momentan. Contactați administratorul.': 'Email updates are currently unavailable. Contact your administrator.',
  'Email invalid. Verificați formatul și încercați din nou.': 'Invalid email address. Check the format and try again.',
  'Parolă incorectă sau nu aveți permisiunea de a actualiza email-ul.': 'Incorrect password, or you do not have permission to update the email address.',
  'Schimbă email': 'Change email',
  'Expirare licență': 'Licence expiry',
  'Salvează date transportator': 'Save carrier details',
  'Se trimite...': 'Sending...',
  'Dezactivează notificări WhatsApp': 'Disable WhatsApp notifications',
  'Activează notificări WhatsApp': 'Enable WhatsApp notifications',
  'Introduceți parola pentru a confirma schimbarea': 'Enter your password to confirm the change',
  'Nu există email setat': 'No email address is set',
  'Confirmă schimbarea': 'Confirm change',
  'Se trimite email-ul...': 'Sending the email...',
  'Am trimis instrucțiunile de resetare a parolei la adresa': 'We sent password reset instructions to',
  'Se încarcă profilul...': 'Loading profile...',
  'Deconectează-te': 'Sign out',

  // Per diem and monthly AROBS components
  'Introdu un număr valid de zile.': 'Enter a valid number of days.',
  'Luna selectată nu este validă.': 'The selected month is invalid.',
  'Valoarea nu este validă.': 'The value is invalid.',
  'Diurna lunară necesită funcțiile Profitabilitate și Management personal.': 'Monthly per diem requires the Profitability and Workforce Management features.',
  'Nu ai permisiunea de a administra diurnele șoferilor.': 'You do not have permission to manage driver per diem.',
  'Nu am putut încărca diurnele șoferilor.': 'Could not load driver per diem.',
  'Introdu o sumă pozitivă cu maximum două zecimale.': 'Enter a positive amount with no more than two decimal places.',
  'Selectează EUR sau RON.': 'Select EUR or RON.',
  'Conversia RON–EUR nu este disponibilă momentan. Încearcă din nou mai târziu.': 'RON–EUR conversion is currently unavailable. Please try again later.',
  'Șoferul nu mai aparține companiei. Reîncarcă tabelul.': 'The driver is no longer assigned to the company. Reload the table.',
  'Diurnă lunară pe șofer': 'Monthly Per Diem by Driver',
  'Configurează rata zilnică și zilele pentru luna selectată. Conversia este calculată și păstrată automat.': 'Configure the daily rate and days for the selected month. The conversion is calculated and saved automatically.',
  'Se încarcă șoferii…': 'Loading drivers…',
  'Valoare convertită': 'Converted Value',
  'Diurnele șoferilor nu au putut fi încărcate. Încearcă din nou.': 'Driver per diem could not be loaded. Try again.',
  'Nu există șoferi în companie.': 'There are no drivers in the company.',
  'Firma nu este configurată': 'The company is not configured',
  'Deschide aplicația folosind subdomeniul primit de la administratorul firmei.': 'Open the application using the subdomain provided by your company administrator.',
  'Datele AROBS nu au putut fi încărcate.': 'Could not load the AROBS data.',
  'Nu a fost programat niciun camion.': 'No trucks were scheduled.',
  'Sincronizarea AROBS nu s-a putut realiza pentru unele camioane.': 'AROBS synchronisation could not be completed for some trucks.',
  'Sincronizare lunară AROBS': 'Monthly AROBS Synchronisation',
  'Rezultatele sunt procesate în fundal și actualizate automat.': 'Results are processed in the background and updated automatically.',
  'Se programează...': 'Scheduling...',
  'Sincronizează camioanele': 'Synchronise trucks',
  'Km sincronizați': 'Kilometres synchronised',
  'De reîncercat': 'Retry required',
  'Acțiune': 'Action',
  'Resincronizează': 'Synchronise again',
  'Nu există camioane AROBS pentru luna selectată.': 'There are no AROBS trucks for the selected month.',
  'Se încarcă rezultatele...': 'Loading results...',

  // Authentication, sessions, and account security
  'Sesiunea a expirat sau a fost revocată.': 'Your session has expired or was revoked.',
  'Sesiunea nu este validă pentru firma curentă.': 'This session is not valid for the current company.',
  'Introdu numărul de telefon asociat contului tău.': 'Enter the phone number associated with your account.',
  'Introdu parola contului tău.': 'Enter your account password.',
  'Nu am găsit un cont cu aceste date. Verifică numărul de telefon și parola.': 'We could not find an account with these details. Check the phone number and password.',
  'Contul tău are 2FA activat dar nu are email setat. Contactează administratorul.': 'Two-factor authentication is enabled for your account, but no email address is configured. Contact your administrator.',
  'Alege rolul cu care vrei să te autentifici pentru acest număr.': 'Choose the role you want to use for this phone number.',
  'Serverul nu răspunde în acest moment. Te rugăm să încerci din nou mai târziu.': 'The server is not responding at the moment. Please try again later.',
  'A apărut o problemă neașteptată. Încearcă din nou.': 'An unexpected problem occurred. Please try again.',
  'Nu putem stabili conexiunea cu serverul. Verifică internetul și încearcă din nou.': 'Could not connect to the server. Check your internet connection and try again.',
  'A apărut o problemă neașteptată. Dacă persistă, contactează echipa de suport.': 'An unexpected problem occurred. If it persists, contact the support team.',
  'Se autentifică...': 'Signing in...',
  'Sunt mai multe conturi active pe acest număr.': 'There are multiple active accounts associated with this number.',
  'Intră': 'Continue',
  'Link invalid. Vă rugăm solicitați un nou link de resetare.': 'Invalid link. Please request a new reset link.',
  'Parola trebuie să aibă cel puțin 8 caractere': 'The password must be at least 8 characters long',
  'Parola trebuie să conțină cel puțin o literă mare': 'The password must contain at least one uppercase letter',
  'Parola trebuie să conțină cel puțin o literă mică': 'The password must contain at least one lowercase letter',
  'Parola trebuie să conțină cel puțin o cifră': 'The password must contain at least one number',
  'Parola a fost schimbată. Autentifică-te din nou.': 'Your password has been changed. Sign in again.',
  'Link-ul de resetare a expirat sau este invalid. Vă rugăm solicitați un nou link.': 'The reset link has expired or is invalid. Please request a new link.',
  'Introduceți parola nouă': 'Enter the new password',
  'Resetează parola': 'Reset password',
  'Codul trebuie să aibă 6 cifre.': 'The code must contain 6 digits.',
  'Autentificare reușită! Te redirecționăm...': 'Authentication successful! Redirecting...',
  'A apărut o eroare neașteptată. Te rugăm să încerci din nou.': 'An unexpected error occurred. Please try again.',
  'Nu am putut retrimite codul. Te rugăm să încerci din nou.': 'Could not resend the code. Please try again.',
  'Verificare în 2 pași': 'Two-Step Verification',
  'încercare rămasă': 'attempt remaining',
  'încercări rămase': 'attempts remaining',
  'Ai epuizat toate încercările. Solicită un cod nou.': 'You have used all available attempts. Request a new code.',
  'Verifică codul': 'Verify code',
  '← Înapoi la autentificare': '← Back to sign in',
  'Eroare la încărcarea statusului 2FA.': 'Error loading two-factor authentication status.',
  'Nu am putut încărca statusul 2FA. Te rugăm să încerci din nou.': 'Could not load two-factor authentication status. Please try again.',
  'Nu am putut încărca email-ul. Încearcă din nou.': 'Could not load the email address. Please try again.',
  'Email salvat. Poți activa 2FA.': 'Email address saved. You can now enable two-factor authentication.',
  'Adaugă mai întâi o adresă de email validă pentru a primi codurile 2FA.': 'Add a valid email address before enabling two-factor authentication codes.',
  'Autentificarea în doi pași a fost activată cu succes!': 'Two-factor authentication was enabled successfully!',
  'Nu poți activa 2FA fără o adresă de email validă. Te rugăm să adaugi un email în profilul tău.': 'You cannot enable two-factor authentication without a valid email address. Add one to your profile first.',
  'Eroare la activarea 2FA.': 'Error enabling two-factor authentication.',
  'Nu am putut activa 2FA. Te rugăm să încerci din nou.': 'Could not enable two-factor authentication. Please try again.',
  'Te rugăm să introduci parola.': 'Enter your password.',
  'Autentificarea în doi pași a fost dezactivată.': 'Two-factor authentication was disabled.',
  'Parolă incorectă. Te rugăm să încerci din nou.': 'Incorrect password. Please try again.',
  'Eroare la dezactivarea 2FA.': 'Error disabling two-factor authentication.',
  'Nu am putut dezactiva 2FA. Te rugăm să încerci din nou.': 'Could not disable two-factor authentication. Please try again.',
  'Salvează email': 'Save email address',
  '📧 Cod unic trimis pe email la fiecare autentificare': '📧 A unique code is sent by email each time you sign in',
  'Eroare la încărcarea sesiunilor.': 'Error loading sessions.',
  'Nu am putut încărca sesiunile. Te rugăm să încerci din nou.': 'Could not load the sessions. Please try again.',
  'Nu poți revoca sesiunea curentă. Folosește butonul de Logout.': 'You cannot revoke the current session. Use the Sign Out button instead.',
  'Sigur vrei să deconectezi acest dispozitiv? Utilizatorul va trebui să se autentifice din nou pe acel dispozitiv.': 'Are you sure you want to sign out this device? The user will need to sign in again on that device.',
  'Sesiunea a fost revocată cu succes.': 'The session was revoked successfully.',
  'Nu am putut revoca sesiunea. Te rugăm să încerci din nou.': 'Could not revoke the session. Please try again.',
  'ATENȚIE: Vei fi deconectat de pe TOATE dispozitivele, inclusiv acesta. Vei trebui să te autentifici din nou. Ești sigur?': 'WARNING: You will be signed out on ALL devices, including this one. You will need to sign in again. Are you sure?',
  'Nu am putut deconecta toate dispozitivele. Te rugăm să încerci din nou.': 'Could not sign out all devices. Please try again.',
  'oră': 'hour',

  // User administration
  'Creează Șofer': 'Create Driver',
  'Eroare la ștergerea utilizatorului:': 'Error deleting the user:',
  'Încearcă să modifici filtrele de căutare.': 'Try changing the search filters.',
  'Încă nu există utilizatori în sistem.': 'There are no users in the system yet.',
  'Fără telefon': 'No phone number',
  'Ultima conectare:': 'Last sign-in:',
  'Parola a fost resetată cu succes.': 'The password was reset successfully.',
  'Eroare la încărcarea bonurilor': 'Error loading receipts',
  'Nu există șoferi care să corespundă căutării "': 'No drivers match the search "',

  // Administrative activity log event descriptions
  'Acces la lista șoferilor refuzat': 'Access to the driver list denied',
  'Acces la detaliile șoferului refuzat': 'Access to driver details denied',
  'Permisiune de creare șofer refuzată': 'Permission to create a driver denied',
  'Modificarea numărului de telefon a eșuat': 'Phone number update failed',
  'A adăugat un șofer nou': 'Added a new driver',
  'Adăugarea șoferului a eșuat': 'Driver creation failed',
  'Eroare la adăugarea șoferului': 'Error adding the driver',
  'A șters un șofer': 'Deleted a driver',
  'Ștergerea șoferului a eșuat': 'Driver deletion failed',
  'A șters un utilizator': 'Deleted a user',
  'A modificat statusul unui șofer': 'Changed a driver status',
  'A consultat lista șoferilor': 'Viewed the driver list',
  'A modificat numărul de telefon': 'Changed the phone number',
  'A încărcat un document': 'Uploaded a document',
  'A șters un document': 'Deleted a document',
  'Ștergerea documentului a fost refuzată': 'Document deletion was denied',
  'Ștergerea documentului a eșuat': 'Document deletion failed',
  'A încărcat un document pentru camion': 'Uploaded a truck document',
  'A șters un document de camion': 'Deleted a truck document',
  'A încărcat un document pentru remorcă': 'Uploaded a trailer document',
  'A șters un document de remorcă': 'Deleted a trailer document',
  'A încărcat un document pentru transport': 'Uploaded a transport document',
  'A șters un document de transport': 'Deleted a transport document',
  'A adăugat un camion nou': 'Added a new truck',
  'Tentativă neautorizată de adăugare camion': 'Unauthorised attempt to add a truck',
  'Tentativă neautorizată de modificare camion': 'Unauthorised attempt to edit a truck',
  'A șters un camion': 'Deleted a truck',
  'Tentativă neautorizată de ștergere camion': 'Unauthorised attempt to delete a truck',
  'A adăugat o remorcă nouă': 'Added a new trailer',
  'Tentativă neautorizată de adăugare remorcă': 'Unauthorised attempt to add a trailer',
  'Tentativă neautorizată de modificare remorcă': 'Unauthorised attempt to edit a trailer',
  'A șters o remorcă': 'Deleted a trailer',
  'Tentativă neautorizată de ștergere remorcă': 'Unauthorised attempt to delete a trailer',
  'Tentativă neautorizată de modificare transport': 'Unauthorised attempt to edit a transport',
  'A șters un transport': 'Deleted a transport',
  'Tentativă neautorizată de ștergere transport': 'Unauthorised attempt to delete a transport',
  'Șoferul a încercat să șteargă transportul': 'The driver attempted to delete the transport',
  'A asignat transportul unui șofer': 'Assigned the transport to a driver',
  'A încărcat fotografii cu marfa': 'Uploaded cargo photos',
  'A șters o fotografie cu marfa': 'Deleted a cargo photo',
  'Tentativă neautorizată de creare CMR': 'Unauthorised attempt to create a CMR',
  'Tentativă neautorizată de modificare CMR': 'Unauthorised attempt to edit a CMR',
  'A șters un document CMR': 'Deleted a CMR document',
  'Accesul cu cod temporar a eșuat': 'Temporary-code access failed',
  'Încălcare de securitate la accesul temporar': 'Security violation during temporary access',
  'A marcat mai multe notificări ca citite': 'Marked multiple notifications as read',
  'A respins mai multe notificări': 'Dismissed multiple notifications',
  'A consultat notificările': 'Viewed notifications',
  'Permisiune de trimitere email refuzată': 'Permission to send email denied',
  'Trimiterea emailului a eșuat': 'Email delivery failed',
  'Permisiune de optimizare rută refuzată': 'Permission to optimise a route denied',
  'A consultat istoricul activităților': 'Viewed the activity history',
  'Eroare la panoul de retenție jurnale': 'Log-retention panel error',
  'Curățare automată zilnică a notificărilor': 'Daily automatic notification cleanup',
  'Eroare la curățarea zilnică automată': 'Daily automatic cleanup failed',
  'Curățare automată săptămânală a jurnalelor': 'Weekly automatic log cleanup',
  'Eroare la curățarea săptămânală automată': 'Weekly automatic cleanup failed',
  'Curățare automată lunară a concediilor': 'Monthly automatic leave cleanup',
  'Eroare la curățarea lunară automată': 'Monthly automatic cleanup failed',
  'A înregistrat o cerere de concediu': 'Recorded a leave request',
  'Tentativă de autentificare eșuată': 'Failed authentication attempt',
  'Avertizare - documentul expiră în curând': 'Warning – document expiring soon',
  'Activitate în sistem': 'System activity',
  'istoricul activităților': 'activity history',
  'notificările': 'notifications',
  'lista șoferilor': 'driver list',
  'filtrat după': 'filtered by',
  'căutare': 'search',
  'a șters': 'deleted',
  'a încărcat': 'uploaded',
  'a eșuat': 'failed',
  'eroare': 'error',
  'Operațiune completată în sistem': 'Operation completed in the system',
  'pentru un anumit șofer': 'for a specific driver',
  'filtrate pe lună': 'filtered by month',
  'Pașaport': 'Passport',
  'A pornit transportul conform programării': 'Started the transport as scheduled',
  'A asignat transportul unui șofer disponibil': 'Assigned the transport to an available driver',
  'A creat un transport nou în sistem': 'Created a new transport in the system',
  'A vizualizat lista camioanelor din flotă': 'Viewed the fleet truck list',
  'A vizualizat lista remorcilor din flotă': 'Viewed the fleet trailer list',
  'A adăugat un camion nou în flotă': 'Added a new truck to the fleet',
  'A adăugat o remorcă nouă în flotă': 'Added a new trailer to the fleet',
  'A modificat statusul operațional al șoferului': "Changed the driver's operational status",
  'A actualizat informațiile unui utilizator': 'Updated user information',
  'A consultat lista șoferilor companiei': "Viewed the company's driver list",
  'A încărcat un document în sistemul de fișiere': 'Uploaded a document to the file system',
  'Sistem: Document cu expirare apropiată': 'System: Document approaching expiry',
  'A modificat informațiile din documentul CMR': 'Changed information in the CMR document',
  'S-a conectat cu succes în platformă': 'Signed in to the platform successfully',
  'Tentativă de conectare cu credențiale incorecte': 'Sign-in attempt with incorrect credentials',
  'Acces refuzat la funcțiile administrative': 'Access to administrative features denied',
  'Tentativă de acces neautorizat detectată': 'Unauthorised access attempt detected',
  'A generat un cod de acces pentru terți': 'Generated a third-party access code',
  'Cod de acces temporar utilizat de terți': 'Temporary access code used by a third party',
  'A înregistrat o nouă cerere de concediu': 'Recorded a new leave request',
  'A consultat istoricul activităților utilizatorilor': 'Viewed user activity history',
  'A verificat notificările din sistem': 'Checked system notifications',
  'A reorganizat ordinea transporturilor în coadă': 'Reordered transports in the queue',
  'Sistem: Curățare automată notificări expirate': 'System: Automatic cleanup of expired notifications',
  'Sistem: Arhivare automată jurnale vechi': 'System: Automatic archival of old logs',
  'A efectuat o operațiune în sistem': 'Performed an operation in the system',
  '🚛 Transport și Rute': '🚛 Transport and Routes',
  '👥 Gestionare Utilizatori': '👥 User Management',
  '📄 Gestionare Documente': '📄 Document Management',
  '🚚 Gestionare Vehicule': '🚚 Vehicle Management',
  '🔒 Securitate și Acces': '🔒 Security and Access',
  '🔔 Notificări': '🔔 Notifications',
  '🤖 Operațiuni Automate': '🤖 Automated Operations',
  '📅 Concedii și Permisiuni': '📅 Leave and Permissions',
  '📋 Documente CMR': '📋 CMR Documents',
  'Data necunoscută': 'Unknown date',
  'Modifică categoria selectată sau termenul de căutare pentru a găsi activități.': 'Change the selected category or search term to find activities.',
  'Nu există activități înregistrate în sistem încă.': 'There is no activity recorded in the system yet.',
  'Actualizează activitățile': 'Refresh activities',

  // Driver observations and trip sheets
  'Nu am putut încărca șoferii și transporturile active.': 'Could not load the drivers and active transports.',
  'Nu am putut încărca observațiile.': 'Could not load the notes.',
  'Observația a fost adăugată cu succes.': 'The note was added successfully.',
  'Nu am putut adăuga observația.': 'Could not add the note.',
  'Nu am putut șterge observația.': 'Could not delete the note.',
  'Autentificare necesară pentru accesarea paginii.': 'You must sign in to access this page.',
  'Selectează transportul activ': 'Select the active transport',
  'Selectează mai întâi șoferul': 'Select the driver first',
  'Salvează observația': 'Save note',
  'Actualizează lista': 'Refresh list',
  'Transporturile zilei nu au putut fi încărcate. Poți completa manual traseul.': "Today's transports could not be loaded. You can enter the route manually.",
  'Foaia de parcurs nu a putut fi generată.': 'The trip sheet could not be generated.',
  'Se încarcă transporturile zilei…': "Loading today's transports…",
  'Se încarcă autovehiculele…': 'Loading vehicles…',
  'Selectează un camion': 'Select a truck',
  'Fără marcă și model': 'Make and model unavailable',
  'Km în oraș (opțional)': 'Urban kilometres (optional)',
  'Km în afara orașului': 'Extra-urban kilometres',
  'Semnătură șofer': 'Driver signature',
  'Șoferul nu a putut fi încărcat.': 'The driver could not be loaded.',
  'Istoricul nu a putut fi încărcat momentan. Formularul pentru o foaie nouă rămâne disponibil.': 'The history is currently unavailable. The form for a new trip sheet remains available.',
  'Se pregătește documentul…': 'Preparing the document…',
  'Se deschide foaia de parcurs…': 'Opening the trip sheet…',
  'Browserul a blocat fereastra nouă. Permite ferestrele pop-up pentru AtruX și încearcă din nou.': 'The browser blocked the new window. Allow pop-ups for AtruX and try again.',
  'Documentul nu a putut fi deschis. Încearcă din nou.': 'The document could not be opened. Please try again.',
  'Șoferul nu a fost găsit.': 'Driver not found.',
  'Dată indisponibilă': 'Date unavailable',

  // Leave planning
  'Nu s-au putut încărca datele de concediu.': 'Could not load the leave data.',
  'Peste 50% în concediu': 'More than 50% on leave',
  'Peste 10% în concediu': 'More than 10% on leave',
  'Total angajați': 'Total employees',

  // Optifleet tachograph screens
  'Șofer selectat': 'Selected driver',
  'Ai nevoie de acces la planificarea expedițiilor pentru a vedea și modifica expedițiile.': 'You need shipment-planning access to view and edit shipments.',
  'Nu am putut încărca expedițiile.': 'Could not load the shipments.',
  'Ai nevoie de acces la planificarea expedițiilor pentru a vedea expedițiile din luna curentă.': "You need shipment-planning access to view this month's shipments.",
  'Nu am putut încărca expedițiile din luna curentă.': "Could not load this month's shipments.",
  'Serviciul FM-Track nu este disponibil momentan. Încearcă din nou mai târziu.': 'The FM-Track service is currently unavailable. Please try again later.',
  'Șofer curent': 'Current driver',
  'Completează plecarea și sosirea estimată.': 'Enter the departure and estimated arrival.',
  'Intervalul trebuie să fie între 1 și 336 ore.': 'The interval must be between 1 and 336 hours.',
  'Nu am putut actualiza expediția.': 'Could not update the shipment.',
  'Ștergi expediția? Transporturile atașate vor fi detașate, nu șterse.': 'Delete the shipment? Attached transports will be detached, not deleted.',
  'Nu am putut șterge expediția.': 'Could not delete the shipment.',
  'Perioadă personalizată': 'Custom period',
  'Expediții active / programate pentru toți șoferii': 'Active / scheduled shipments for all drivers',
  'Șofer necunoscut': 'Unknown driver',
  'Perioada:': 'Period:',
  'Nu am putut încărca lista de șoferi Optifleet.': 'Could not load the Optifleet driver list.',
  'Selectează o perioadă validă.': 'Select a valid period.',
  'Data de început trebuie să fie înainte de data de sfârșit.': 'The start date must be before the end date.',
  'Nu s-au putut încărca datele șoferului': 'Could not load the driver data',
  'Nu ai permisiuni pentru a accesa datele acestui șofer.': "You do not have permission to access this driver's data.",
  'Serviciul Optifleet nu este disponibil momentan. Încearcă din nou mai târziu.': 'The Optifleet service is currently unavailable. Please try again later.',
  'Perioada selectată nu este validă. Verifică datele selectate.': 'The selected period is invalid. Check the selected dates.',
  'Eroare necunoscută': 'Unknown error',
  'Nu s-au putut încărca datele pentru niciunul dintre șoferi. Verifică conexiunea și încearcă din nou.': 'Data could not be loaded for any driver. Check your connection and try again.',
  'Nu s-au putut încărca datele de activitate.': 'Could not load the activity data.',
  'Nu s-a putut încărca activitatea zilnică.': 'Could not load the daily activity.',
  'Șofer Optifleet': 'Optifleet Driver',
  'Perioadă custom': 'Custom period',
  'sumă pe toți șoferii afișați': 'total for all displayed drivers',
  'Medie / șofer': 'Average / driver',
  'calculată pe șoferii cu condus > 0': 'calculated for drivers with driving time > 0',
  'Top șofer': 'Top driver',
  'Rezumat activități șofer': 'Driver activity summary',
  'Ore de condus pe șofer': 'Driving hours by driver',
  'Timp condus rămas (56h)': 'Remaining driving time (56 h)',
  'A apărut o eroare la încărcarea datelor': 'An error occurred while loading the data',
  'Ora început': 'Start time',
  'Ora sfârșit': 'End time',

  // Shipment planning
  'Detalii săptămână': 'Week details',
  'Selectează data și ora de plecare': 'Select the departure date and time',
  'Plecarea nu poate fi în trecut': 'The departure cannot be in the past',
  'Format invalid pentru data și ora plecării': 'Invalid departure date and time format',
  'Nu există șoferi care se potrivesc.': 'No matching drivers found.',
  'Selectează un șofer din listă.': 'Select a driver from the list.',
  'Dată și oră plecare': 'Departure date and time',
  'Durată (ore)': 'Duration (hours)',
  'Prea multe cereri. Butoanele sunt dezactivate încă': 'Too many requests. The buttons will remain disabled for another',
  'Se creează...': 'Creating...',
  'Creează expediția': 'Create shipment',
  'Se încarcă expedițiile zilei...': "Loading the day's shipments...",
  'Nu există expediții care intersectează această zi.': 'No shipments overlap this day.',
  'Expediție -': 'Shipment -',
  'Fără transporturi atașate.': 'No transports attached.',
  'Durată invalidă': 'Invalid duration',
  'Durata trebuie să fie între 1 și 336 ore.': 'The duration must be between 1 and 336 hours.',
  'Minute sosire estimată': 'Estimated arrival minutes',
  'Șoferul nu este în REST curent. Timer-ul este pe pauză.': 'The driver is not currently resting. The timer is paused.',
  'Confirmă': 'Confirm',
  'Închide mesajul': 'Close message',
  'A apărut o eroare.': 'An error occurred.',
  'Nu am putut încărca grila săptămânală.': 'Could not load the weekly grid.',
  'Nu am putut încărca lista de expediții.': 'Could not load the shipment list.',
  'Nu am putut încărca șoferii blocați.': 'Could not load the blocked drivers.',
  'Nu am putut încărca detaliul șoferului.': 'Could not load the driver details.',
  'Nu am putut încărca lista de șoferi disponibili.': 'Could not load the available driver list.',
  'Nu am putut încărca detaliile zilei.': 'Could not load the day details.',
  'Nu am putut crea expediția.': 'Could not create the shipment.',
  'Durata expediției a fost actualizată': 'The shipment duration was updated',
  'Nu am putut actualiza durata expediției': 'Could not update the shipment duration',
  'Nu am putut actualiza durata expediției.': 'Could not update the shipment duration.',
  'Expediția a fost actualizată.': 'The shipment was updated.',
  'Expediția a fost finalizată': 'The shipment was completed',
  'Expediția apare acum la Sosiri.': 'The shipment now appears under Arrivals.',
  'Nu am putut finaliza expediția': 'Could not complete the shipment',
  'Nu am putut finaliza expediția.': 'Could not complete the shipment.',
  'Expediția a fost ștearsă.': 'The shipment was deleted.',
  'Ești sigur că vrei să ștergi expediția?': 'Are you sure you want to delete the shipment?',
  'Transporturile atașate vor fi detașate, nu șterse.': 'Attached transports will be detached, not deleted.',
  'Șterge expediția': 'Delete shipment',
  'Finalizezi expediția acum?': 'Complete the shipment now?',
  'Expediția va fi marcată ca finalizată, iar ora de sosire efectivă va fi setată automat la momentul curent.': 'The shipment will be marked as completed and its actual arrival time will be set to the current time automatically.',
  'Depășire 56h/săptămână': '56 h/week limit exceeded',
  'Depășire 90h/2 săptămâni': '90 h/2-week limit exceeded',
  'Marți': 'Tuesday',
  'Sâmbătă': 'Saturday',
  'Duminică': 'Sunday',

  // Profitability configuration and round-trip reporting
  'Extragere facturi LKW': 'LKW invoice extraction',
  'Extragere facturi LKW WALTER': 'LKW WALTER invoice extraction',
  'Factură LKW WALTER': 'LKW WALTER invoice',
  'Facturi LKW WALTER': 'LKW WALTER invoices',
  'Încarcă facturi PDF LKW WALTER și urmărește extragerea celor trei valori validate.': 'Upload LKW WALTER PDF invoices and track extraction of the three validated values.',
  'Încarcă facturile PDF native. Aplicația extrage numărul documentului, totalul EUR și data transportului, fără OCR sau AI.': 'Upload native-text PDF invoices. The application extracts the document number, EUR total, and shipment date without OCR or AI.',
  'Încarcă documentele LKW, extrage toate pozițiile și pregătește ciorna editabilă pentru facturare.': 'Upload LKW documents, extract every line, and prepare the editable invoice draft.',
  'Încarcă facturile PDF native. După extragere, aplicația pregătește toate pozițiile într-o ciornă de factură complet editabilă.': 'Upload native-text PDF invoices. After extraction, the application prepares every line in a fully editable invoice draft.',
  'Pregătit': 'Ready',
  'În așteptare': 'Waiting',
  'Se încarcă': 'Uploading',
  'Încărcat': 'Uploaded',
  'În coadă': 'Queued',
  'Se extrage': 'Extracting',
  'Finalizat': 'Completed',
  'Total': 'Total',
  'Finalizate': 'Completed',
  'Eșuate': 'Failed',
  'Alege PDF-urile': 'Choose the PDFs',
  'Maximum 500 de fișiere, 10 MiB fiecare și 2 GiB pe lot.': 'Up to 500 files, 10 MiB each, and 2 GiB per batch.',
  'Încarcă documentele': 'Upload the documents',
  'Fiecare PDF este trimis separat, cu maximum trei încărcări simultane.': 'Each PDF is sent separately, with up to three concurrent uploads.',
  'Așteaptă extragerea': 'Wait for extraction',
  'Procesarea rulează în fundal, iar progresul se actualizează automat.': 'Processing runs in the background and progress updates automatically.',
  'Editează factura': 'Edit the invoice',
  'Verifică pozițiile, corectează câmpurile și adaugă sau șterge linii.': 'Review the lines, correct fields, and add or delete entries.',
  'Verifică rezultatele': 'Review the results',
  'Erorile individuale nu elimină documentele procesate cu succes.': 'Individual errors do not discard successfully processed documents.',
  'PDF-uri pentru acest lot': 'PDFs for this batch',
  'Sunt acceptate doar facturi LKW WALTER PDF cu text nativ, neprotejate și de maximum 50 de pagini.': 'Only unprotected, native-text LKW WALTER PDF invoices of up to 50 pages are accepted.',
  'Elimină fișierele neîncărcate': 'Remove files not yet uploaded',
  'Adaugă PDF-uri': 'Add PDFs',
  'Trage PDF-urile aici sau alege-le din calculator': 'Drop PDFs here or choose them from your computer',
  'Încărcarea este în desfășurare': 'Upload in progress',
  'Continuă lotul deschis': 'Continue the open batch',
  'Lot nou pregătit': 'New batch ready',
  'Limitările temporare sunt respectate automat; fișierele acceptate nu sunt retrimise.': 'Temporary limits are handled automatically; accepted files are not uploaded again.',
  'Oprește după încărcările curente': 'Stop after current uploads',
  'Încarcă și pornește extragerea': 'Upload and start extraction',
  'Fișiere neacceptate la încărcare': 'Files rejected during upload',
  'Aceste fișiere nu au intrat în lot. Rezultatele documentelor acceptate rămân disponibile mai jos.': 'These files were not added to the batch. Results for accepted documents remain available below.',
  'Fișierul nu a putut fi încărcat.': 'The file could not be uploaded.',
  'Se pregătesc toate pozițiile facturii…': 'Preparing all invoice lines…',
  'Pozițiile facturii nu au putut fi pregătite.': 'The invoice lines could not be prepared.',
  'Reîncearcă': 'Try again',
  'Ciornă factură LKW WALTER': 'LKW WALTER invoice draft',
  'Netrimisă': 'Not sent',
  'Pozițiile sunt construite în forma facturii SmartBill de referință și rămân complet editabile. Nimic nu este trimis către SmartBill.': 'The lines follow the reference SmartBill invoice format and remain fully editable. Nothing is sent to SmartBill.',
  'Salvare automată în acest browser': 'Automatically saved in this browser',
  'Reîncarcă extragerea': 'Reload extracted data',
  'Descarcă tabel CSV': 'Download CSV table',
  'Adaugă poziție': 'Add line',
  'Ciorna nu a putut fi salvată în acest browser. Descarcă tabelul înainte să părăsești pagina.': 'The draft could not be saved in this browser. Download the table before leaving the page.',
  'Datele din PDF care alimentează poziția sunt: numărul documentului, totalul EUR și data transportului. Data este completată în câmpul „Data din descriere”; verific-o înainte de emitere dacă ai nevoie de data documentului LKW.': 'The PDF supplies the document number, EUR total, and shipment date. The date is placed in “Date in description”; review it before issuing if you need the LKW document date.',
  'Datele facturii și ale clientului': 'Invoice and customer details',
  'Seria, numărul și datele calendaristice nu există în documentele extrase și trebuie completate înainte de emitere.': 'The series, number, and invoice dates are not present in the extracted documents and must be completed before issuing.',
  'Serie': 'Series',
  'Număr factură': 'Invoice number',
  'Se va aloca în SmartBill': 'Will be assigned in SmartBill',
  'Data scadenței': 'Due date',
  'CIF / VAT client': 'Customer tax / VAT ID',
  'Adresă client': 'Customer address',
  'Mențiuni factură': 'Invoice notes',
  'Opțional; completează formularea validată de contabil': 'Optional; enter the wording approved by your accountant',
  'Poziții': 'Lines',
  'Valoare fără TVA': 'Amount excluding VAT',
  'Total factură': 'Invoice total',
  'Caută în pozițiile facturii': 'Search invoice lines',
  'Caută document, dată sau fișier sursă': 'Search by document, date, or source file',
  'Document sursă': 'Source document',
  'Denumire produs / serviciu': 'Product / service name',
  'Data din descriere': 'Date in description',
  'Cant.': 'Qty.',
  'Preț unitar': 'Unit price',
  'TVA %': 'VAT %',
  'Valoare TVA': 'VAT amount',
  'Adăugată manual': 'Added manually',
  'Nu există poziții care să corespundă căutării.': 'No lines match the search.',
  'Reîncarci toate pozițiile din datele extrase? Modificările locale și liniile adăugate manual vor fi eliminate.': 'Reload every line from the extracted data? Local changes and manually added lines will be removed.',
  'Organizare lunară': 'Monthly organisation',
  'Facturare lunară': 'Monthly billing',
  'Alege luna facturii LKW': 'Choose the LKW invoice month',
  'Toate loturile lunii alimentează aceeași ciornă și rămân disponibile în istoric.': 'All batches for the month feed the same draft and remain available in history.',
  'Luna contabilă': 'Accounting month',
  'Documente': 'Documents',
  'PDF-uri încărcate': 'Uploaded PDFs',
  'Procesate tehnic': 'Technically processed',
  'În lucru': 'Processing',
  'Poziții facturabile': 'Billable lines',
  'Duplicate ignorate': 'Ignored duplicates',
  'De verificat': 'Needs review',
  'Total de facturat': 'Amount to invoice',
  'Duplicate': 'Duplicates',
  'Poziții active': 'Active lines',
  'Procesate': 'Processed',
  'Total ciornă': 'Draft total',
  'Nu există încă luni cu documente LKW.': 'There are no months with LKW documents yet.',
  'Lunile LKW nu au putut fi încărcate.': 'The LKW months could not be loaded.',
  'Loturile încărcate în aceeași lună completează aceeași ciornă de factură.': 'Batches uploaded for the same month complete the same invoice draft.',
  'Încarcă alt lot în această lună': 'Upload another batch for this month',
  'Luna este stabilită': 'Month selected',
  'Maximum 500 de documente în fiecare lot.': 'Up to 500 documents in each batch.',
  'Extrage datele': 'Extract data',
  'Încărcare controlată și procesare în fundal.': 'Controlled upload and background processing.',
  'Actualizează ciorna': 'Update the draft',
  'Pozițiile valide sunt adăugate automat în luna selectată.': 'Valid lines are added automatically to the selected month.',
  'PDF nativ, neprotejat, maximum 10 MiB și 50 de pagini.': 'Native-text, unprotected PDF, up to 10 MiB and 50 pages.',
  'Se încarcă ciorna lunară…': 'Loading the monthly draft…',
  'Nu există încă o ciornă pentru această lună': 'There is no draft for this month yet',
  'Ciorna va fi creată automat când începi primul lot de documente LKW pentru luna selectată.': 'The draft will be created automatically when you start the first LKW document batch for the selected month.',
  'Ciornă lunară LKW WALTER': 'Monthly LKW WALTER draft',
  'Factură finalizată LKW WALTER': 'Finalized LKW WALTER invoice',
  'Snapshot local blocat': 'Locked local snapshot',
  'Poziții valide': 'Valid lines',
  'Vezi factura finalizată': 'View finalized invoice',
  'Verifică și finalizează': 'Review and finalize',
  'Vezi factura': 'View invoice',
  'Vezi ciorna': 'View draft',
  'Ciornă lunară — date extrase': 'Monthly draft — extracted data',
  'Înapoi la extragere': 'Back to extraction',
  'Reîncarcă': 'Reload',
  'MiB/fișier': 'MiB/file',
  'Recalculează': 'Recalculate',
  'Descarcă CSV': 'Download CSV',
  'Poziție manuală': 'Manual line',
  'Adaugă poziție manuală': 'Add manual line',
  'Poziția va fi salvată în ciorna lunară și va intra în totalurile facturii.': 'The line will be saved in the monthly draft and included in invoice totals.',
  'Denumire serviciu': 'Service name',
  'Data documentului': 'Document date',
  'Preț unitar EUR': 'EUR unit price',
  'Salvează poziția': 'Save line',
  'Ciorna lunară nu a putut fi încărcată.': 'The monthly draft could not be loaded.',
  'Ciorna se actualizează încă. Reîncearcă după finalizarea procesării documentelor.': 'The draft is still updating. Try again after document processing finishes.',
  'Ciorna a fost modificată între timp de alt utilizator sau de procesarea documentelor. Modificările tale nesalvate sunt păstrate pe ecran.': 'The draft was changed by another user or by document processing. Your unsaved changes remain on screen.',
  'Am încărcat cea mai recentă versiune a facturii și am reaplicat modificările tale. Verifică informațiile înainte de salvare.': 'We loaded the latest invoice version and reapplied your changes. Review the information before saving.',
  'Renunță la modificările nesalvate': 'Discard unsaved changes',
  'Antetul facturii': 'Invoice header',
  'Finalizare locală': 'Local finalization',
  'Factura este finalizată': 'The invoice is finalized',
  'Finalizată local': 'Finalized locally',
  'Editabilă': 'Editable',
  'Salvează modificările curente înainte de finalizare.': 'Save the current changes before finalizing.',
  'Finalizează factura local': 'Finalize invoice locally',
  'Confirmă finalizarea': 'Confirm finalization',
  'Se finalizează…': 'Finalizing…',
  'Finalizarea este doar în AtruX. Nu se emite și nu se trimite automat nicio factură către Oblio sau ANAF.': 'Finalization only takes place in AtruX. No invoice is automatically issued or sent to Oblio or ANAF.',
  'Completează informațiile disponibile. Câmpurile necunoscute pot rămâne necompletate.': 'Complete the available information. Unknown fields may remain empty.',
  'Salvează antetul': 'Save header',
  'Număr': 'Number',
  'Furnizor': 'Supplier',
  'CIF furnizor': 'Supplier tax ID',
  'Adresă furnizor': 'Supplier address',
  'Bancă': 'Bank',
  'Mențiuni': 'Notes',
  'Antetul nu a putut fi salvat.': 'The header could not be saved.',
  'Poziția nu a putut fi salvată.': 'The line could not be saved.',
  'Poziția manuală nu a putut fi adăugată.': 'The manual line could not be added.',
  'Poziția nu a putut fi restaurată.': 'The line could not be restored.',
  'Poziția nu a putut fi exclusă.': 'The line could not be excluded.',
  'Ordinea pozițiilor nu a putut fi salvată.': 'The line order could not be saved.',
  'Ciorna nu a putut fi recalculată.': 'The draft could not be recalculated.',
  'Răspunsul salvării nu a fost confirmat. Ciorna a fost reîncărcată; verifică dacă poziția există înainte să încerci din nou.': 'The save response was not confirmed. The draft was reloaded; check whether the line exists before trying again.',
  'Caută document, dată sau origine': 'Search by document, date, or origin',
  'Arată pozițiile excluse': 'Show excluded lines',
  'Poz.': 'Pos.',
  'Origine': 'Origin',
  'Net': 'Net',
  'Exclusă': 'Excluded',
  'Extras din PDF': 'Extracted from PDF',
  'Restaurează': 'Restore',
  'Exclude': 'Exclude',
  'Sus': 'Up',
  'Jos': 'Down',
  'Nu există poziții pentru filtrele selectate': 'There are no lines for the selected filters',
  'Istoric LKW WALTER': 'LKW WALTER history',
  'Documente, loturi și modificări salvate pentru luna selectată.': 'Documents, batches, and changes saved for the selected month.',
  'Include arhivate': 'Include archived',
  'Extrageri': 'Extractions',
  'Loturi': 'Batches',
  'Audit': 'Audit',
  'Fără lună': 'Unassigned',
  'Se încarcă istoricul…': 'Loading history…',
  'Istoricul LKW nu a putut fi încărcat.': 'The LKW history could not be loaded.',
  'Documente procesate': 'Processed documents',
  'Încărcat de': 'Uploaded by',
  'Data încărcării': 'Upload date',
  'Arhivează': 'Archive',
  'Mută în altă lună': 'Move to another month',
  'Mută lotul în altă lună': 'Move batch to another month',
  'Luna destinație': 'Destination month',
  'Mută lotul': 'Move batch',
  'Se mută…': 'Moving…',
  'Lună blocată': 'Locked month',
  'Nu există loturi pentru această lună': 'There are no batches for this month',
  'Fișier': 'File',
  'Observații': 'Notes',
  'Sursă': 'Source',
  'Extragere eșuată': 'Extraction failed',
  'Document duplicat · neinclus în ciornă': 'Duplicate document · not included in draft',
  'Document duplicat · neinclus în factură': 'Duplicate document · not included in invoice',
  'Neinclus în ciornă': 'Not included in draft',
  'Inclus în ciorna lunară': 'Included in the monthly draft',
  'Nu există extrageri pentru această lună': 'There are no extractions for this month',
  'Încarcă un lot nou, iar documentele și rezultatele vor apărea aici.': 'Upload a new batch and its documents and results will appear here.',
  'Nu există evenimente de audit pentru această lună': 'There are no audit events for this month',
  'Sistem': 'System',
  'Modificare': 'Change',
  'Anterior': 'Previous',
  'Nou': 'New',
  'Nu există loturi fără lună': 'There are no unassigned batches',
  'Toate loturile istorice sunt deja organizate pe luni.': 'All historical batches are already organised by month.',
  'Lotul nu a putut fi arhivat.': 'The batch could not be archived.',
  'Lotul nu a putut fi atribuit lunii selectate.': 'The batch could not be assigned to the selected month.',
  'PDF-ul nu a putut fi descărcat.': 'The PDF could not be downloaded.',
  'PDF-ul sursă nu a putut fi descărcat.': 'The source PDF could not be downloaded.',
  'Arhivezi acest lot? Pozițiile active provenite din lot vor fi excluse din ciornă și din total, dar PDF-urile, rezultatele și auditul vor fi păstrate. Lotul nu poate fi dezarhivat în această etapă.': 'Archive this batch? Its active lines will be excluded from the draft and total, but PDFs, results, and audit history will be kept. The batch cannot be unarchived at this stage.',
  'Rezultatele extragerii': 'Extraction results',
  'Actualizează': 'Refresh',
  'Lot nou': 'New batch',
  'Lot': 'Batch',
  'Caută în pagina de rezultate': 'Search this results page',
  'Caută fișier, număr document sau eroare': 'Search by file, document number, or error',
  'Document': 'Document',
  'Număr document': 'Document number',
  'Data transportului': 'Shipment date',
  'Detalii': 'Details',
  'Extras cu succes': 'Extracted successfully',
  'Procesarea continuă': 'Processing continues',
  'Nu există rezultate pe această pagină.': 'There are no results on this page.',
  'Înapoi': 'Previous',
  'Înainte': 'Next',
  'Se reia lotul LKW WALTER…': 'Resuming the LKW WALTER batch…',
  'Se reia lotul LKW WALTER': 'Resuming the LKW WALTER batch',
  'Se verifică starea documentelor…': 'Checking document status…',
  'Se pregătesc documentele…': 'Preparing the documents…',
  'Se încarcă documentele LKW': 'Uploading LKW documents',
  'Se pregătește lotul…': 'Preparing the batch…',
  'Poți continua să lucrezi în pagină.': 'You can continue working on this page.',
  'Lotul LKW a fost reluat': 'The LKW batch was resumed',
  'Poți continua încărcarea documentelor.': 'You can continue uploading documents.',
  'Lotul nu a putut fi creat. Încearcă din nou.': 'The batch could not be created. Try again.',
  'Niciun PDF nu a fost acceptat. Lotul nu poate fi pornit.': 'No PDF was accepted. The batch cannot be started.',
  'Lotul nu a putut fi pornit.': 'The batch could not be started.',
  'Lotul depășește limita totală de 2 GiB': 'The batch exceeds the 2 GiB total limit',
  'Cererea de extragere LKW WALTER nu a putut fi procesată.': 'The LKW WALTER extraction request could not be processed.',
  'Alege luna raportului': 'Choose the report month',
  'Selectează luna pentru care vrei să vezi raportul financiar.': 'Select the month whose financial report you want to view.',
  'Alege luna': 'Choose a month',
  'Sunt disponibile toate lunile din anul curent.': 'All months in the current year are available.',
  'Luna nu a putut fi pregătită. Încearcă din nou.': 'The month could not be prepared. Try again.',
  'Selectează categoria diurnei.': 'Select the per diem category.',
  'Națională': 'National',
  'Internațională': 'International',
  'RON — Leu românesc': 'RON — Romanian leu',
  'Editează sumele lunare folosite automat în raportul de profitabilitate.': 'Edit the monthly amounts used automatically in the profitability report.',
  'Nu am putut încărca salariile și diurnele.': 'Could not load salaries and per diem.',
  'Diurna zilnică nu este validă.': 'The daily per diem is invalid.',
  'Nu am putut salva valorile șoferului.': 'Could not save the driver values.',
  'Șoferi afișați': 'Drivers displayed',
  'Luna activă': 'Active month',
  'Diurnă configurată': 'Per diem configured',
  'Diurnă neconfigurată': 'Per diem not configured',
  'Caută numărul de zile...': 'Search by number of days...',
  'Lipsă': 'Missing',
  'Nespecificată': 'Not specified',
  'Alocat după durata curselor': 'Allocated by trip duration',
  'Alocat după zilele curselor': 'Allocated by trip days',
  'Șoferul nu a putut fi asociat cu setarea de salariu': 'The driver could not be matched to the salary setting',
  'Echipajul nu are un interval activ în luna raportului': 'The crew has no active interval in the reporting month',
  'Salariul este configurat, dar nu a putut fi alocat; verifică perioada echipajului': 'The salary is configured but could not be allocated; check the crew period',
  'Unele transporturi nu au camion înregistrat în AROBS. Se pot introduce manual kilometrii.': 'Some transports do not have a truck registered in AROBS. Kilometres can be entered manually.',
  'Facturi camion · distribuit după zile active': 'Truck invoices · allocated by active days',
  'Traseu': 'Route',
  'Nu am putut încărca raportul.': 'Could not load the report.',
  'Nu există rânduri de exportat pentru luna și filtrele selectate.': 'There are no rows to export for the selected month and filters.',
  'Documentul încărcat nu a fost identificat ca document de combustibil. Verifică fișierul și încearcă din nou.': 'The uploaded document was not identified as a fuel document. Check the file and try again.',
  'AI nu a găsit linii de combustibil sau taxe de drum în documentele încărcate.': 'The AI found no fuel or road-toll entries in the uploaded documents.',
  'Nu există linii pregătite pentru import.': 'There are no entries ready to import.',
  'Factura a fost salvată definitiv în profitabilitate. Raportul nu a putut fi reîncărcat acum, dar nu trebuie să imporți factura din nou.': 'The invoice was saved permanently in profitability. The report could not be reloaded now, but you do not need to import the invoice again.',
  'Factura a fost salvată, dar combustibilul nu a putut fi alocat în raport. Verifică dacă există transporturi cu zile active pentru camion în luna facturii.': 'The invoice was saved, but the fuel could not be allocated in the report. Check that the truck has transports with active days in the invoice month.',
  'și': 'and',
  'Respingi această cursă tur-retur? Transporturile nu vor fi șterse, dar grupul nu va mai intra în profitabilitate.': 'Reject this round trip? The transports will not be deleted, but the group will no longer be included in profitability.',
  'Statusul grupului s-a modificat între timp. Raportul a fost actualizat.': 'The group status changed in the meantime. The report has been updated.',
  'Grupul nu mai există. Actualizează raportul și încearcă din nou.': 'The group no longer exists. Refresh the report and try again.',
  'Nu există curse tur-retur în tabel pentru sincronizare.': 'There are no round trips in the table to synchronise.',
  'Poți sincroniza maximum 100 de curse tur-retur într-o singură cerere.': 'You can synchronise up to 100 round trips in a single request.',
  'Generează raportul tur-retur înainte de a edita totalurile lunii.': 'Generate the round-trip report before editing the monthly totals.',
  'Data de sfârșit a grupului trebuie să fie după data de început.': 'The group end date must be after its start date.',
  'grupul nu mai apare în raport după salvare': 'the group no longer appears in the report after saving',
  'data de început a grupului nu corespunde valorii salvate': 'the group start date does not match the saved value',
  'data finală a grupului nu corespunde valorii salvate': 'the group end date does not match the saved value',
  'Nu am putut salva modificările de profitabilitate.': 'Could not save the profitability changes.',
  'Pentru o setare nouă alege cel puțin camionul și șoferul.': 'For a new setting, select at least the truck and driver.',
  'Setarea lunară a fost salvată.': 'The monthly setting was saved.',
  'Nu am putut salva setarea lunară.': 'Could not save the monthly setting.',
  'Cheltuielile nu au putut fi salvate. Verifică valorile și încearcă din nou.': 'The expenses could not be saved. Check the values and try again.',
  'Salariile și diurnele nu au putut fi încărcate. Încearcă din nou.': 'Salaries and per diem could not be loaded. Try again.',
  'Valorile șoferului nu au putut fi salvate. Verifică informațiile și încearcă din nou.': 'The driver values could not be saved. Check the information and try again.',
  'Raportul nu a putut fi încărcat. Încearcă din nou.': 'The report could not be loaded. Try again.',
  'Cursele tur-retur nu au putut fi generate. Verifică perioada și încearcă din nou.': 'The round trips could not be generated. Check the period and try again.',
  'Raportul PDF nu a putut fi generat. Încearcă din nou.': 'The PDF report could not be generated. Try again.',
  'Documentele nu au putut fi citite. Verifică fișierele și încearcă din nou.': 'The documents could not be read. Check the files and try again.',
  'Datele din facturi nu au putut fi importate. Verifică informațiile și încearcă din nou.': 'The invoice data could not be imported. Check the information and try again.',
  'Grupul nu a putut fi finalizat. Reîncarcă raportul și încearcă din nou.': 'The group could not be completed. Reload the report and try again.',
  'Grupul nu a putut fi respins. Reîncarcă raportul și încearcă din nou.': 'The group could not be rejected. Reload the report and try again.',
  'Kilometrii nu au putut fi actualizați acum. Încearcă din nou în câteva momente.': 'The kilometres could not be updated right now. Try again in a few moments.',
  'Totalurile lunii nu au putut fi salvate. Verifică valorile și încearcă din nou.': 'The monthly totals could not be saved. Check the values and try again.',
  'Modificările nu au putut fi salvate. Verifică valorile și încearcă din nou.': 'The changes could not be saved. Check the values and try again.',
  'Setarea lunară nu a putut fi salvată. Verifică valorile și încearcă din nou.': 'The monthly setting could not be saved. Check the values and try again.',
  'metodă de alocare necunoscută': 'unknown allocation method',
  'valoare ajustată manual': 'manually adjusted value',
  'estimare pe kilometru': 'per-kilometre estimate',
  'Utilizator #': 'User #',
  'Distribuire configurată manual': 'Manually Configured Allocation',
  'Nu există distribuiri configurate manual.': 'There are no manually configured allocations.',
  'Generează automat': 'Generate automatically',
  'Se exportă...': 'Exporting...',
  'Salarii și diurne șoferi': 'Driver salaries and per diem',
  'Cheltuieli camioane': 'Truck expenses',
  'Cheltuieli remorci': 'Trailer expenses',
  'Combustibil, taxe, diurnă și alte cheltuieli': 'Fuel, tolls, per diem, and other expenses',
  'Vehicule, remorci și salariile șoferilor activi': 'Vehicles, trailers, and active-driver salaries',
  'Salarii șoferi (lună)': 'Driver salaries (month)',
  'Incluse în costurile fixe și în profitul net': 'Included in fixed costs and net profit',
  'Distribuit proporțional cu zilele transporturilor': 'Allocated proportionally by transport days',
  'Profit curse după alocări': 'Trip profit after allocations',
  'Salarii și cost camion incluse': 'Salaries and truck costs included',
  'Caută camionul...': 'Search for a truck...',
  'Editează grupul': 'Edit group',
  'transporturi': 'transports',
  'Început grup': 'Group start',
  'Sfârșit grup': 'Group end',
  'Denumire traseu (opțional)': 'Route name (optional)',
  'Note (opțional)': 'Notes (optional)',
  'Salvează nota': 'Save note',
  'Analiza este în coadă...': 'Analysis queued...',
  'AI procesează documentele...': 'AI is processing the documents...',
  'Se citește cu AI...': 'Reading with AI...',
  'Nu am putut încărca cursurile valutare.': 'Could not load the exchange rates.',
  'Încarcă facturi': 'Upload invoices',
  'Pregătită pentru distribuire': 'Ready for allocation',
  'Caută moneda...': 'Search for a currency...',
  '· cursul valutar nu este disponibil momentan.': '· the exchange rate is currently unavailable.',
  '· se calculează echivalentul în EUR.': '· the EUR equivalent is being calculated.',
  '· aceasta este valoarea care va apărea în EUR în profitabilitate.': '· this is the value that will appear in EUR in profitability.',
  'necesită verificare': 'requires review',
  'Se sincronizează km...': 'Synchronising kilometres...',
  'Tur-returul trebuie închis înainte de sincronizare': 'The round trip must be closed before synchronisation',
  'Sincronizează kilometrii AROBS pentru perioada tur-returului': 'Synchronise AROBS kilometres for the round-trip period',
  'Sincronizare în curs': 'Synchronisation in progress',
  'Reîncearcă AROBS': 'Retry AROBS',
  'Transporturi:': 'Transports:',
  'Total tabel afișat': 'Displayed table total',
  'Total lună': 'Monthly total',
  'Transporturi grup #': 'Group transports #',
  'Informativ, neinclus în totaluri': 'For information only; not included in totals',
  'proporțional cu durata curselor': 'proportional to trip duration',
  'proporțional cu zilele curselor': 'proportional to trip days',
  'rată zilnică lunară': 'monthly daily rate',
  'Note corecție lunară': 'Monthly adjustment notes',
  'Salvează totalurile': 'Save totals',
  'Fără dispecer': 'No dispatcher',
  'Niciun camion eligibil.': 'No eligible trucks.',
  'Rată': 'Rate',
  'Nicio remorcă eligibilă.': 'No eligible trailers.',
  'Șoferi activi': 'Active drivers',
  'Setare nouă': 'New setting',
  'Alege șofer': 'Choose driver',
  'Fără user': 'No user',
  'Editează setare existentă': 'Edit existing setting',
  'Asigurare marfă (compatibilitate)': 'Cargo insurance (compatibility)',
  'Actualizează setare': 'Update setting',
  'Adaugă setare': 'Add setting',

  // Driver transport status reporting
  'Fără oprire specifică': 'No specific stop',
  'Locație nespecificată': 'Location not specified',
  'Nu am putut încărca istoricul statusului vehiculului.': 'Could not load the vehicle status history.',
  'Atașează cel puțin o fotografie.': 'Attach at least one photo.',
  'Fotografiile au fost trimise către dispecerat.': 'The photos were sent to dispatch.',
  'Nu am putut trimite statusul vehiculului.': 'Could not send the vehicle status.',
  'Descrie problema înainte de trimitere.': 'Describe the problem before submitting it.',
  'Problema a fost raportată către dispecerat.': 'The problem was reported to dispatch.',
  'Nu am putut raporta problema. Încearcă din nou.': 'Could not report the problem. Please try again.',
  'Funcțional': 'Operational',
  'Problemă': 'Problem',
  'Pornire nespecificată': 'Start not specified',
  'Destinație nespecificată': 'Destination not specified',
  'Remorca': 'Trailer',
  'Schimbă fotografiile': 'Change photos',
  'Erori': 'Errors',
  'Nu există semnatari actuali salvați pentru acest CMR.': 'There are no current signatories saved for this CMR.',
  'Nu există CMR digital pentru acest transport.': 'There is no digital CMR for this transport.',
  'Schimbă fotografia': 'Change photo',
  'Raportează problema': 'Report problem',
  'Raportează statusul vehiculului': 'Report vehicle status',
  'Atașează până la 10 fotografii și 3 video pentru camion, remorcă sau situația observată.': 'Attach up to 10 photos and 3 videos of the truck, trailer, or observed situation.',
  'Adaugă fotografii': 'Add photos',
  'Adaugă video': 'Add video',
  'Atașează cel puțin o fotografie sau un video.': 'Attach at least one photo or video.',
  'Raportul media a fost trimis către dispecerat.': 'The media report was sent to dispatch.',
  'Se încarcă atașamentele': 'Uploading attachments',
  'Trimite raportul': 'Send report',
  'Atașamente nereguli': 'Issue attachments',
  'Nu există atașamente pentru problemele acestui transport': 'There are no attachments for this transport’s issues',
  'Previzualizarea video nu este disponibilă. Deschide fișierul original.': 'Video preview is unavailable. Open the original file.',
  'Deschide sau descarcă video': 'Open or download video',
  'Fișierul selectat nu este valid.': 'The selected file is invalid.',
  'Conexiunea a fost întreruptă în timpul încărcării. Verifică istoricul înainte de a retrimite.': 'The connection was interrupted during upload. Check the history before submitting again.',
  'Trimiterea a fost anulată. Verifică istoricul înainte de a retrimite.': 'The upload was cancelled. Check the history before submitting again.',

  // Differential audit: remaining visible labels and validation branches
  'Alege tipul documentului...': 'Choose the document type...',
  'disponibile': 'available',
  'Rezumatul cererilor aprobate/respinse': 'Summary of approved/rejected requests',
  'Una sau mai multe resurse nu sunt disponibile.': 'One or more resources are unavailable.',
  'Datele transportatorului au fost salvate.': 'The carrier details were saved.',
  'Nu am putut salva datele transportatorului.': 'Could not save the carrier details.',
  'Email actualizat cu succes! ✓': 'Email address updated successfully! ✓',
  'Actualizat': 'Updated',
  'Salariu profitabilitate (EUR)': 'Profitability salary (EUR)',
  'Transport activ *': 'Active transport *',
  'Documentul nu a primit un link nou. Încearcă din nou.': 'The document did not receive a new link. Try again.',
  'Salariul nu este valid.': 'The salary is invalid.',
  'Salariu lunar (EUR)': 'Monthly salary (EUR)',
  'Costuri fixe (doar raport complet)': 'Fixed costs (full report only)',
  'Atrux · Raport generat automat': 'AtruX · Automatically generated report',
  'PDF-ul raportului a fost generat.': 'The report PDF was generated.',
  'Nu am putut genera PDF-ul raportului.': 'Could not generate the report PDF.',
  'Nu am putut citi facturile cu AI.': 'Could not read the invoices with AI.',
  'Nu am putut importa datele din facturi.': 'Could not import the invoice data.',
  'Nu am putut finaliza grupul.': 'Could not complete the group.',
  'Nu ai permisiunea de a respinge acest grup.': 'You do not have permission to reject this group.',
  'Nu am putut respinge grupul.': 'Could not reject the group.',
  'Totalurile lunii au fost actualizate.': 'The monthly totals were updated.',
  'Venituri': 'Revenue',
  'Nu s-au detectat linii de combustibil.': 'No fuel entries were detected.',
  'Alimentare #': 'Fuel entry #',
  'Motivul ștergerii este obligatoriu.': 'The deletion reason is required.',
  'Șterge poziția': 'Delete line',
  'Poziția va fi eliminată din registru, iar motivul rămâne disponibil în istoricul documentului.': 'The line will be removed from the register, and the reason will remain available in the document history.',
  'Poziția a fost ștearsă.': 'The line was deleted.',
  'grupuri': 'groups',
  'Grup #': 'Group #',
  'Grup exclus din calculele de profitabilitate.': 'Group excluded from profitability calculations.',
  '+ salariu alocat grupului': '+ salary allocated to the group',
  'Grup respins, exclus din totaluri': 'Rejected group, excluded from totals',
  'Transport #': 'Transport #',
  'Kilometri': 'Kilometres',
  'Venit': 'Revenue',
  'grupaj': 'consolidation',
  'Combustibil (EUR)': 'Fuel (EUR)',
  'Niciun salariu activ inclus.': 'No active salaries included.',
  'Salariu': 'Salary',
  'Venit:': 'Revenue:',
  'Alocat:': 'Allocated:',
  'Raport #': 'Report #',
  'Raportat la:': 'Reported on:',
  'Actualizat:': 'Updated:',
  'Sesiunea a expirat.': 'Your session has expired.',
  'Titlu Document *': 'Document Title *',
  'Selectează un șofer': 'Select a driver',
  'Ianuarie': 'January',
  'Februarie': 'February',
  'Martie': 'March',
  'Aprilie': 'April',
  'Mai': 'May',
  'Iunie': 'June',
  'Iulie': 'July',
  'August': 'August',
  'Septembrie': 'September',
  'Octombrie': 'October',
  'Noiembrie': 'November',
  'Decembrie': 'December',

  // Residual route copy without Romanian diacritics. These labels are kept in
  // the compatibility pack until their owning routes move to semantic keys.
  'Plecare': 'Departure',
  'Condus': 'Driving',
  'Date tahograf': 'Tachograph data',
  'Ore conduse': 'Hours driven',
  'Raport ore de condus': 'Driving-hours report',
  'Total condus': 'Total driving time',
  'Repartizare timp': 'Time breakdown',
  'Raport Zilnic': 'Daily Report',
  'Lucru': 'Work',
  'HUF - Forint maghiar': 'HUF - Hungarian forint',
  'PLN - Zlot polonez': 'PLN - Polish zloty',
  'Componente grupaj': 'Consolidation components',
  'componente': 'components',
  'Metri podea ocupati': 'Occupied loading metres',
  'Aviz': 'Delivery note',
  'Model necunoscut': 'Unknown model',
  'Tip necunoscut': 'Unknown type',
  'Grupaj': 'Consolidation',
  'Un singur pret pe transport': 'One price per transport',
  'Creare transport': 'Create transport',
  'Mod creare': 'Creation mode',
  'Transport pe baza de aviz': 'Transport from delivery note',
  'Avize PDF / Word / poze standard *': 'Delivery-note PDFs / Word files / standard photos *',
  'CMR-uri care se vor crea': 'CMRs to be created',
  'Date preluate din aviz': 'Data extracted from the delivery note',
  'Opriri detectate:': 'Detected stops:',
  'Date preluate din document': 'Data extracted from the document',
  'Opriri transport': 'Transport stops',
  'OBLIGATORIU': 'REQUIRED',
  'Transportator subcontractat *': 'Subcontracted carrier *',
  'Cost transportator *': 'Carrier cost *',
  'Numele companiei/persoanei expeditoare': 'Sender company/person name',
  'Numele companiei/persoanei destinatare': 'Recipient company/person name',
  'COD UIT': 'UIT CODE',
  'Cod UIT / UIT code': 'UIT code',
  'Denumire *': 'Name *',
  'Document aviz original': 'Original delivery-note document',
  'Transportul a fost creat, dar documentul original nu a fost disponibil.': 'The transport was created, but the original document was unavailable.',
  'Completare Aviz Transport': 'Complete Transport Delivery Note',
  'Revizuire Aviz importat': 'Review Imported Delivery Note',
  'Zoom orar:': 'Timeline zoom:',
  'Mod': 'Mode',
  'Raport Zilnic Tahograf': 'Daily Tachograph Report',
  'Date generale': 'General details',
  'Unitatea': 'Unit',
  'Selectat': 'Selected',
  'Persoane': 'People',
  'Calculat de': 'Calculated by',
  'Sosire': 'Arrival',
  'Foi de parcurs': 'Trip sheets',
  'Istoric foi de parcurs': 'Trip-sheet history',
  'Raport Zilnic Tahograf Optifleet': 'Optifleet Daily Tachograph Report',
  'Timp estimat': 'Estimated time',
  'Cost timp:': 'Time cost:',
  'Cost Taxa Drum': 'Road-toll cost',
  'Semnate': 'Signed',
  'Oprire': 'Stop',
  'Probleme raportate': 'Reported problems',
  'Motiv:': 'Reason:',
  'Blocat la:': 'Blocked at:',
  'Blocat:': 'Blocked:',
  'rezultat(e)': 'result(s)',
  'Minute plecare': 'Departure minutes',
  'status necunoscut': 'unknown status',
  'In curs de deblocare': 'Unlocking in progress',
  'Mai trebuie': 'Time remaining',
  'Timer-ul live poate fi stale, deblocarea se va face la 5 AM': 'The live timer may be stale; unlocking will occur at 5:00 AM',
  'Cod UIT': 'UIT code',
  'Data creare': 'Created on',
  'Partener comercial': 'Business partner',
  'Transportator': 'Carrier',
  'CIF declarant': 'Declarant tax ID (CIF)',
  'Rezultate pentru': 'Results for',
  'Din lista ANAF': 'From the ANAF list',
  'Creare transport nou': 'Create new transport',
  'Email destinatar:': 'Recipient email:',
  'EMAIL DESTINATAR': 'RECIPIENT EMAIL',
  'Client nou': 'New customer',
  'Transportator nou': 'New carrier',
  'CMR nou': 'New CMR',
  'NUME DESTINATAR': 'RECIPIENT NAME',
  'AI a citit „': 'AI read “',
  'Nu am putut deschide foile de parcurs': 'Could not open the trip sheets',
  'Se deschide…': 'Opening…',
  'Partener nou': 'New partner',
  'Ex: Partener Logistic SRL': 'Example: Logistics Partner Ltd',
  'Costuri Monetare': 'Monetary costs',
  'Fotografii': 'Photos',
  'Fotografii Nereguli': 'Issue photos',
  'Nicio plecare': 'No departure',
  'Nicio sosire': 'No arrival',
  'Ora sosirii estimate': 'Estimated arrival time',
  'UIT nespecificat': 'UIT not specified',
  'Coduri UIT': 'UIT codes',

  // Residual operational UI found by the strict whole-application audit.
  'rest': 'rest',
  'EUR/zi': 'EUR/day',
  'Livrare:': 'Delivery:',
  'Semnatar General': 'General Signatory',
  'Nume indisponibil': 'Name unavailable',
  'Cod': 'Code',
  'semnatar general': 'general signatory',
  'Partenerii de la care sunt preluate comenzile intermediate.': 'Partners whose brokered orders are imported.',
  'Partenerul nu a putut fi creat.': 'The partner could not be created.',
  'Nu am putut salva cheltuielile.': 'Could not save the expenses.',
  'Salarii configurate': 'Configured salaries',
  'Curs fixat: 1 EUR =': 'Fixed exchange rate: EUR 1 =',
  'Estimare intarziere': 'Estimated delay',
  'Status Marfa': 'Goods Status',
  'Status Cuplare': 'Coupling Status',
  'Unde este problema?': 'Where is the issue?',
  'Rest': 'Rest',
  'Rest acumulat': 'Accumulated rest',
  'Sosiri': 'Arrivals',
  'Luni': 'Monday',
  'Miercuri': 'Wednesday',
  'Joi': 'Thursday',
  'Vineri': 'Friday',
  'Componenta': 'Component',
  'Transport simplu': 'Single transport',
  'Note interne': 'Internal notes',
  'Primul pas': 'First step',
  'Selectez manual': 'Select manually',
  'Configurat': 'Configured',
  'Neasociat': 'Unassigned',
  'Consum (l/100 km)': 'Consumption (l/100 km)',
  'Status selectat': 'Selected status',
  'Document transport': 'Transport document',
  'Note': 'Notes',
  'Act': 'Document No.',
});

const MONTHS = Object.freeze({
  Ianuarie: 'January', Februarie: 'February', Martie: 'March', Aprilie: 'April',
  Mai: 'May', Iunie: 'June', Iulie: 'July', August: 'August',
  Septembrie: 'September', Octombrie: 'October', Noiembrie: 'November', Decembrie: 'December',
});

const KNOWN_DYNAMIC_LABELS = Object.freeze({
  Toate: 'All',
  Documente: 'Documents',
  Șoferi: 'Drivers',
  Transporturi: 'Transports',
  'Documente încărcate': 'Uploaded documents',
  'Parola actuală': 'current password',
  'Parola nouă': 'new password',
  'Confirmă parola nouă': 'new password confirmation',
  'Cheltuieli camioane': 'truck expenses',
  'Cheltuieli remorci': 'trailer expenses',
  'Rată lunară': 'Monthly rate',
  Amortizare: 'Depreciation',
  RCA: 'Third-party liability insurance',
  CASCO: 'Comprehensive insurance',
  'Asigurare marfă': 'Cargo insurance',
});

const translateKnownDynamicLabel = (value) => KNOWN_DYNAMIC_LABELS[value] || value;

const translateProfitabilityVerification = (value) => {
  const replacements = [
    [/^transportul #(\S+) nu mai apare în grup$/, 'transport #$1 no longer appears in the group'],
    [/^valoarea ajustată a diurnei pentru transportul #(\S+) nu a fost salvată$/, 'the adjusted per diem value for transport #$1 was not saved'],
    [/^diurna transportului #(\S+) este înlocuită de alocarea lunară$/, 'the per diem for transport #$1 is overridden by the monthly allocation'],
    [/^valoarea ajustată a combustibilului pentru transportul #(\S+) nu a fost salvată$/, 'the adjusted fuel value for transport #$1 was not saved'],
    [/^combustibilul transportului #(\S+) este înlocuit de factura alocată$/, 'the fuel for transport #$1 is overridden by the allocated invoice'],
    [/^venitul transportului #(\S+) nu a fost salvat$/, 'the revenue for transport #$1 was not saved'],
    [/^venitul transportului #(\S+) este calculat din componentele de grupaj$/, 'the revenue for transport #$1 is calculated from its consolidation components'],
    [/^moneda venitului pentru transportul #(\S+) nu corespunde valorii salvate$/, 'the revenue currency for transport #$1 does not match the saved value'],
    [/^moneda venitului pentru transportul #(\S+) nu a fost salvată$/, 'the revenue currency for transport #$1 was not saved'],
    [/^taxele de drum ale transportului #(\S+) nu au fost salvate$/, 'the road tolls for transport #$1 were not saved'],
    [/^taxele de drum ale transportului #(\S+) nu corespund valorii salvate$/, 'the road tolls for transport #$1 do not match the saved value'],
    [/^kilometrii manuali ai transportului #(\S+) nu au fost salvați$/, 'the manually entered kilometres for transport #$1 were not saved'],
    [/^kilometrii transportului #(\S+) nu corespund valorii salvate$/, 'the kilometres for transport #$1 do not match the saved value'],
    [/^data de început a transportului #(\S+) nu corespunde valorii salvate$/, 'the start date for transport #$1 does not match the saved value'],
    [/^data finală a transportului #(\S+) nu corespunde valorii salvate$/, 'the end date for transport #$1 does not match the saved value'],
    [/^traseul transportului #(\S+) nu corespunde valorii salvate$/, 'the route for transport #$1 does not match the saved value'],
    [/^statusul grupului nu corespunde valorii salvate$/, 'the group status does not match the saved value'],
    [/^denumirea traseului grupului nu corespunde valorii salvate$/, 'the group route name does not match the saved value'],
    [/^notele grupului nu corespund valorii salvate$/, 'the group notes do not match the saved value'],
    [/^grupul nu mai apare în raport după salvare$/, 'the group no longer appears in the report after saving'],
    [/^data de început a grupului nu corespunde valorii salvate$/, 'the group start date does not match the saved value'],
    [/^data finală a grupului nu corespunde valorii salvate$/, 'the group end date does not match the saved value'],
  ];
  const match = replacements.find(([pattern]) => pattern.test(value));
  return match ? value.replace(match[0], match[1]) : value;
};

// Dynamic UI produced by template literals cannot be represented by exact
// lookups. Patterns preserve identifiers and user/company values verbatim.
export const legacyEnglishOperationsPatterns = Object.freeze([
  [/^Pasul (\d+)$/u, 'Step $1'],
  [/^(\d+) din (\d+) procesate$/u, '$1 of $2 processed'],
  [/^(\d+) selectate · (.+)$/u, '$1 selected · $2'],
  [/^Reîncercare în (\d+) secunde…$/u, 'Retrying in $1 seconds…'],
  [/^Fișierele au fost primite\. Lotul pornește în (\d+) secunde…$/u, 'Files received. The batch will start in $1 seconds…'],
  [/^(\d+) documente încărcate\. Lotul a rămas deschis și poate fi continuat\.$/u, '$1 documents uploaded. The batch remains open and can be continued.'],
  [/^(\d+) documente încărcate(?: · (\d+) încărcări eșuate)?\. Extragerea a început\.$/u, (_, uploaded, failed) => `${uploaded} documents uploaded${failed ? ` · ${failed} uploads failed` : ''}. Extraction started.`],
  [/^Pagina (\d+) din (\d+)$/u, 'Page $1 of $2'],
  [/^Elimină (.+)$/u, 'Remove $1'],
  [/^Limita disponibilă este de (\d+) documente$/u, 'The available limit is $1 documents'],
  [/^(.+): este deja în listă$/u, '$1: already in the list'],
  [/^(.+): este acceptat doar formatul PDF$/u, '$1: only PDF files are accepted'],
  [/^(.+): depășește 10 MiB$/u, '$1: exceeds 10 MiB'],
  [/^Se pregătește raportul pentru (.+)…$/u, 'Preparing the report for $1…'],
  [/^Introdu între 0\.01 și (\d+) zile\.$/, 'Enter between 0.01 and $1 days.'],
  [
    /^Denumirea (clientului|transportatorului) este obligatorie\.$/u,
    (_, owner) => `The ${owner === 'clientului' ? 'customer' : 'carrier'} name is required.`,
  ],
  [/^din aviz: (.+)$/u, 'from delivery note: $1'],
  [/^(\d+) avize selectate: (.+)$/u, '$1 delivery notes selected: $2'],
  [/^Creat din aviz: (.+)$/u, 'Created from delivery note: $1'],
  [/^Data transport: (.+)$/u, 'Transport date: $1'],
  [/^Nu am putut salva modificările\.\s+(.+)$/, 'Could not save the changes. $1'],
  [
    /^Raportul lunar pentru (.+) (\d{4}) a fost descărcat cu succes!$/,
    (_, month, year) => `The monthly report for ${MONTHS[month] || month} ${year} was downloaded successfully!`,
  ],
  [/^Raportul anual pentru (\d{4}) a fost descărcat cu succes!$/, 'The annual report for $1 was downloaded successfully!'],
  [/^Eroare la ștergerea utilizatorului:\s*(.+)$/u, 'Error deleting the user: $1'],
  [/^Eroare la încărcarea cozii:\s*(.+)$/u, 'Error loading the queue: $1'],
  [/^Eroare la salvarea ordinii:\s*(.+)$/u, 'Error saving the order: $1'],
  [/^Eroare la generarea raportului lunar:\s*(.+)$/u, 'Error generating the monthly report: $1'],
  [/^Eroare la generarea raportului anual:\s*(.+)$/u, 'Error generating the annual report: $1'],
  [/^Înapoi de pe (.+)$/, 'Back from $1'],
  [/^(\d+)m în urmă$/, '$1m ago'],
  [/^(\d+)h în urmă$/, '$1h ago'],
  [
    /^Nu aveți notificări pentru categoria "(.+)"\.$/,
    (_, category) => `You have no notifications in the “${translateKnownDynamicLabel(category)}” category.`,
  ],
  [
    /^(Afișează|Ascunde) (Parola actuală|Parola nouă|Confirmă parola nouă)$/,
    (_, action, label) => `${action === 'Afișează' ? 'Show' : 'Hide'} ${translateKnownDynamicLabel(label)}`,
  ],
  [/^Numărul de zile nu poate depăși (\d+)\.$/, 'The number of days cannot exceed $1.'],
  [/^Introdu între 1 și (\d+) zile\.$/, 'Enter between 1 and $1 days.'],
  [/^Utilizator: (.+)$/, 'User: $1'],
  [/^Utilizator #(\S+)$/, 'User #$1'],
  [/^Transport: (.+)$/, 'Transport: $1'],
  [/^Document: (.+)$/, 'Document: $1'],
  [/^Parola pentru (.+) a fost resetată cu succes!$/, 'The password for $1 was reset successfully!'],
  [/^Eroare la actualizarea accesului Optifleet: (.+)$/, 'Error updating Optifleet access: $1'],
  [/^Prea multe solicitări\. Reîncearcă în (\d+) secunde\.$/, 'Too many requests. Try again in $1 seconds.'],
  [/^Prea multe încercări\. Reîncearcă în (\d+) secunde\.$/, 'Too many attempts. Try again in $1 seconds.'],
  [/^Expediții pentru (.+)$/, 'Shipments for $1'],
  [/^Expediții active \/ programate pentru (.+)$/, 'Active / scheduled shipments for $1'],
  [/^Sofer #(\S+)$/, 'Driver #$1'],
  [
    /^(\d+) transporturi găsite · (\d+) segmente de traseu$/,
    (_, transports, segments) => `${transports} ${Number(transports) === 1 ? 'transport' : 'transports'} found · ${segments} route ${Number(segments) === 1 ? 'segment' : 'segments'}`,
  ],
  [/^Șterge traseul (.+)$/, 'Delete route $1'],
  [/^(\d+) în concediu \((\d+(?:[.,]\d+)?)%\)$/, '$1 on leave ($2%)'],
  [/^Șofer (.+)$/, 'Driver $1'],
  [/^Nu s-au putut încărca datele pentru șoferul selectat\.\s*(.*)$/, 'Could not load the data for the selected driver. $1'],
  [/^Șoferi procesați: (\d+)$/, 'Drivers processed: $1'],
  [
    /^Nu am putut încărca (.+)\.$/,
    (_, label) => `Could not load ${translateKnownDynamicLabel(label)}.`,
  ],
  [
    /^Valoarea pentru (.+) nu este validă\.$/,
    (_, label) => `The value for ${translateKnownDynamicLabel(label)} is invalid.`,
  ],
  [
    /^(Camion|Remorcă) (.+) a fost actualizat\.$/,
    (_, entity, name) => `${entity === 'Camion' ? 'Truck' : 'Trailer'} ${name} was updated.`,
  ],
  [/^Numărul de zile trebuie să fie între 1 și (\d+)\.$/, 'The number of days must be between 1 and $1.'],
  [/^Salariul și diurna pentru (.+) au fost actualizate\.$/, 'The salary and per diem for $1 were updated.'],
  [/^Moneda diurnei pentru (.+)$/, 'Per diem currency for $1'],
  [/^Număr zile pentru (.+)$/, 'Number of days for $1'],
  [
    /^(Ianuarie|Februarie|Martie|Aprilie|Mai|Iunie|Iulie|August|Septembrie|Octombrie|Noiembrie|Decembrie) (\d{4})$/,
    (_, month, year) => `${MONTHS[month]} ${year}`,
  ],
  [
    /^(Cheltuieli camioane|Cheltuieli remorci) · (Ianuarie|Februarie|Martie|Aprilie|Mai|Iunie|Iulie|August|Septembrie|Octombrie|Noiembrie|Decembrie) (\d{4})$/,
    (_, title, month, year) => `${title === 'Cheltuieli camioane' ? 'Truck expenses' : 'Trailer expenses'} · ${MONTHS[month]} ${year}`,
  ],
  [/^Camion: (.+)$/, 'Truck: $1'],
  [/^Camion #(\S+)$/, 'Truck #$1'],
  [/^Remorcă #(\S+)$/, 'Trailer #$1'],
  [/^Sofer: (.+)$/, 'Driver: $1'],
  [/^Pagina (\d+)\/(\d+)$/, 'Page $1/$2'],
  [/^(\d+) grupuri exportate$/, '$1 groups exported'],
  [
    /^Generate: (\d+) grupuri tur-retur\.(?: (\d+) trimise la sincronizare AROBS\.)?$/,
    (_, groups, queued) => `Generated: ${groups} round-trip ${Number(groups) === 1 ? 'group' : 'groups'}.${queued ? ` ${queued} sent for AROBS synchronisation.` : ''}`,
  ],
  [
    /^Au fost extrase (\d+) alimentări\. Verifică datele, apoi apasă „Aplică în profitabilitate” ca să fie salvate și distribuite în tabel\.$/,
    '$1 fuel entries were extracted. Review the data, then select “Apply to profitability” to save and allocate them in the table.',
  ],
  [/^Corectează cele (\d+) linii de combustibil marcate „De verificat” înainte de import\.$/, 'Correct the $1 fuel entries marked “Needs review” before importing.'],
  [
    /^Factura a fost salvată, dar (\d+) alimentări nu au putut fi distribuite\. Verifică camionul, moneda și perioada\.$/,
    'The invoice was saved, but $1 fuel entries could not be allocated. Check the truck, currency, and period.',
  ],
  [
    /^Factura a fost aplicată pentru (.+), iar acum este deschis raportul (.+)\. Selectează luna facturii pentru a vedea combustibilul\.$/,
    'The invoice was applied to $1, and report $2 is currently open. Select the invoice month to view the fuel allocation.',
  ],
  [/^(\d+) facturi combustibil$/, (_, count) => `${count} fuel ${Number(count) === 1 ? 'invoice' : 'invoices'}`],
  [/^(\d+) linii taxe drum$/, (_, count) => `${count} road-toll ${Number(count) === 1 ? 'entry' : 'entries'}`],
  [
    /^Import finalizat și salvat: (.+)\. Datele rămân disponibile și după reîncărcarea paginii\.$/,
    (_, summary) => {
      const translatedSummary = summary
        .replace(/(\d+) facturi combustibil/g, (_, count) => `${count} fuel ${Number(count) === 1 ? 'invoice' : 'invoices'}`)
        .replace(/(\d+) linii taxe drum/g, (_, count) => `${count} road-toll ${Number(count) === 1 ? 'entry' : 'entries'}`)
        .replace(/ și /g, ' and ');
      return `Import completed and saved: ${translatedSummary}. The data remains available after the page is reloaded.`;
    },
  ],
  [/^Grupul #(\S+) a fost inclus în raportul final\.$/, 'Group #$1 was included in the final report.'],
  [/^Grupul #(\S+) a fost respins și exclus din profitabilitate\.$/, 'Group #$1 was rejected and excluded from profitability.'],
  [/^La transportul #(\S+), data finală trebuie să fie după data de început\.$/, 'For transport #$1, the end date must be after the start date.'],
  [
    /^Unele modificări nu apar în raport: (.+)\.$/,
    (_, details) => `Some changes are not reflected in the report: ${details.split('; ').map(translateProfitabilityVerification).join('; ')}.`,
  ],
  [/^Rândul #(\S+) a fost actualizat\.$/, 'Row #$1 was updated.'],
  [/^(\d+) grupuri, (\d+) finalizate$/, '$1 groups, $2 completed'],
  [/^(.+) nealocat transporturilor$/, '$1 not allocated to transports'],
  [/^(\d+) grupuri de verificat$/, '$1 groups requiring review'],
  [/^Include (.+) costuri fixe, din care (.+) salarii șoferi$/, 'Includes $1 in fixed costs, of which $2 is driver salaries'],
  [/^Moneda documentului (.+)$/, 'Currency for document $1'],
  [/^Șterge alimentarea (.+)$/, 'Delete fuel entry $1'],
  [/^Moneda alimentării (.+)$/, 'Currency for fuel entry $1'],
  [/^se aplică pe (.+)$/, 'applies to $1'],
  [
    /^(\d+) (zi|zile|oră|ore|minut|minute) rămase$/,
    (_, count, unit) => {
      const units = { zi: 'day', zile: 'days', oră: 'hour', ore: 'hours', minut: 'minute', minute: 'minutes' };
      return `${count} ${units[unit]} remaining`;
    },
  ],
  [/^Imaginea (.+) depășește limita de 10 MB\.$/, 'Image $1 exceeds the 10 MB limit.'],
  [/^Raport #(\S+)$/, 'Report #$1'],
  [/^Previzualizare (.+)$/, 'Preview $1'],
  [/^Video raport (.+)$/, 'Report video $1'],
  [/^Elimină (.+)$/, 'Remove $1'],
  [/^Neregulă (.+)$/, 'Issue $1'],
  [/^Durata trebuie să fie între (\d+) și (\d+) ore$/, 'The duration must be between $1 and $2 hours'],
  [/^Expediția a fost creată cu succes pentru (.+)\.$/, 'The shipment was created successfully for $1.'],
  [/^Durată nouă: (.+) \((.+)h\)$/, 'New duration: $1 ($2 h)'],
  [/^Sosire estimată: (.+)$/, 'Estimated arrival: $1'],
  [/^Prea multe cereri\. Reîncearcă în (\d+)s\.$/, 'Too many requests. Try again in $1s.'],
  [/^Salvare automată în acest browser · ultima salvare la (.+)$/, 'Automatically saved in this browser · last saved at $1'],
  [/^Versiunea (\d+)$/, 'Version $1'],
  [/^Renunță la modificările nesalvate și reîncarcă versiunea (\d+)$/, 'Discard unsaved changes and reload version $1'],
  [/^Reîncarcă versiunea (\d+) și păstrează câmpurile editate$/, 'Reload version $1 and keep edited fields'],
  [/^Încarcă documente pentru (.+)$/, 'Upload documents for $1'],
  [
    /^Date extrase pentru (Ianuarie|Februarie|Martie|Aprilie|Mai|Iunie|Iulie|August|Septembrie|Octombrie|Noiembrie|Decembrie) (\d{4}) · (\d+) (poziție|poziții) · (.+)$/,
    (_, month, year, count, unit, total) => `Extracted data for ${MONTHS[month]} ${year} · ${count} ${Number(count) === 1 ? 'line' : 'lines'} · ${total}`,
  ],
  [
    /^Verifică și editează toate informațiile facturii pentru (Ianuarie|Februarie|Martie|Aprilie|Mai|Iunie|Iulie|August|Septembrie|Octombrie|Noiembrie|Decembrie) (\d{4})\.$/,
    (_, month, year) => `Review and edit all invoice information for ${MONTHS[month]} ${year}.`,
  ],
  [/^(\d+) documente istorice fără lună$/, '$1 historical documents without a month'],
  [/^(\d+) din (\d+) documente transmise$/, '$1 of $2 documents uploaded'],
  [/^(\d+) din (\d+) documente procesate$/, '$1 of $2 documents processed'],
  [/^(\d+) documente sunt deja încărcate$/, '$1 documents are already uploaded'],
  [/^(\d+) din (\d+)$/, '$1 of $2'],
  [/^(\d+)\/(\d+) procesate · (\d+) eșuate$/, '$1/$2 processed · $3 failed'],
  [/^(\d+) documente · încărcat (.+)$/, '$1 documents · uploaded $2'],
  [/^Atribuie lunii (\d{4}-\d{2})$/, 'Assign to $1'],
  [/^Atribui lotul selectat lunii (\d{4}-\d{2})\? Luna nu va mai putea fi schimbată ulterior\.$/, 'Assign the selected batch to $1? Its month cannot be changed later.'],
  [/^(\d+) poziții au câmpuri lipsă sau valori numerice invalide și trebuie verificate\.$/, '$1 lines have missing fields or invalid numeric values and must be reviewed.'],
  [/^(\d+) din (\d+) poziții$/, '$1 of $2 lines'],
  [/^Pagina (\d+) din (\d+)$/, 'Page $1 of $2'],
  [/^Șterge poziția (\d+)$/, 'Delete line $1'],
  [
    /^Expediția a fost ștearsă\. (\d+) transport\(uri\) au fost detașate\.$/,
    (_, count) => `The shipment was deleted. ${count} ${Number(count) === 1 ? 'transport was' : 'transports were'} detached.`,
  ],
  [/^Reîncearcă în (\d+)s$/, 'Try again in $1s'],
]);
